'use client';

import { ResponsiveImage, type ResponsiveImageProps } from '../ResponsiveImage';
import { VideoPlayer } from '../VideoPlayer';
import { cn } from '../_lib/utils';
import type { SanityImage } from '../types';

export type MediaProps = {
	className?: string;
	image?: SanityImage;
	objectFit?: ResponsiveImageProps['objectFit'];
	video?: string;
	priority?: boolean;
	pauseVideo?: boolean;
	setPauseVideo?: Function;
	aspectRatio?: string;
	nextImageSizes?: string;
};

export function Media(props: MediaProps) {
	return (
		<div className={cn('@container', props.className)} data-component='Media'>
			{props.image && !props.video && (
				<ResponsiveImage
					image={props.image}
					objectFit={props.objectFit}
					priority={props.priority}
					aspectRatio={props.aspectRatio}
					sizes={props.nextImageSizes}
				/>
			)}
			{props.video && (
				<VideoPlayer
					autoplay={true}
					video={props.video}
					pauseVideo={props.pauseVideo}
					setPauseVideo={props.setPauseVideo}
					preload={props.priority}
				/>
			)}
		</div>
	);
}
